import React, { useState } from "react";
import "./LoginModal.css"; // используем те же стили, что и у LoginModal
import ContactInput from "./ContactInput";
import axios from "../axios";

function PasswordResetModal({ onClose }) {
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState("");
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleSendResetCode = async () => {
    setError("");
    try {
      await axios.post("/api/send-reset-code/", {
        contact: identifier,
      });

      const isEmail = identifier.includes("@");
      setMessage(`✅ Ο 6-ψήφιος κωδικός εστάλη στο ${isEmail ? "email" : "τηλέφωνο"}.`);
      setStep(2);
    } catch (err) {
      const data = err.response?.data;
      let msg = "❌ Σφάλμα κατά την αποστολή κωδικού.";

      if (data?.error) msg = data.error;
      else if (data?.contact?.[0]) msg = data.contact[0];

      setError(msg);
    }
  };

  const handleVerifyCode = async () => {
    setError("");
    try {
      await axios.post("/api/verify-reset-code/", {
        contact: identifier,
        code,
      });


      setMessage(""); // очищаем старое сообщение перед шагом 3
      setStep(3);
    } catch (err) {
      const data = err.response?.data;
      let msg = "❌ Λανθασμένος ή ληγμένος κωδικός.";

      if (data?.error) msg = data.error;
      else if (data?.code?.[0]) msg = data.code[0];

      setError(msg);
    }
  };

const handleChangePassword = async () => {
  setError("");

console.log("newPassword:", newPassword);
console.log("confirmPassword:", confirmPassword);

  // 💡 Проверка на пустые поля
  if (!newPassword || !confirmPassword) {
    setError("❌ Όλα τα πεδία είναι υποχρεωτικά.");
    return;
  }

  // 💡 Проверка на совпадение паролей
  if (newPassword !== confirmPassword) {
    setError("❌ Οι κωδικοί δεν ταιριάζουν.");
    return;
  }

  // 💡 Проверка на длину
if (newPassword.length < 6) {
  setError("❌ Ο κωδικός πρέπει να περιέχει τουλάχιστον 6 χαρακτήρες.");
  return;
}

// 💡 Проверка на наличие хотя бы одной английской буквы
if (!/[a-zA-Z]/.test(newPassword)) {
  setError("❌ Ο κωδικός πρέπει να περιέχει τουλάχιστον ένα αγγλικό γράμμα.");
  return;
}

  try {
    await axios.post("/api/reset-password/", {
      contact: identifier,
      code,
      new_password: newPassword,
      confirm_password: confirmPassword,
    });

    setMessage("✅ Ο κωδικός άλλαξε με επιτυχία.");
    setError(""); // сбрасываем ошибку, если всё прошло успешно

    setTimeout(() => {
      onClose();
    }, 2000);
  } catch (err) {
    const data = err.response?.data;
    let msg = "❌ Σφάλμα κατά την αλλαγή του κωδικού.";

    if (data?.new_password?.[0]) msg = data.new_password[0];
    else if (data?.error) msg = data.error;
    else msg = JSON.stringify(data);


    setError(msg);
  }
};


  return (
    <div className="login-modal-content">
      {step === 1 && (
        <div className="step">
          <h2>🔐 Ανάκτηση Κωδικού</h2>
          <p>Εισάγετε το email ή το τηλέφωνο που χρησιμοποιήσατε κατά την εγγραφή.</p>
          <ContactInput value={identifier} onChange={setIdentifier} />
          <button className="green-button" onClick={handleSendResetCode}>
            Αποστολή κωδικού
          </button>
          {error && <div className="auth-error">{error}</div>}
        </div>
      )}

      {step === 2 && (
        <div className="step">
          <h2>📩 Επιβεβαίωση Κωδικού</h2>
          <p>{message}</p>
          <input
            type="text"
            placeholder="6-ψήφιος κωδικός"
            value={code}
            onChange={(e) => setCode(e.target.value)}
          />
          <button className="green-button" onClick={handleVerifyCode}>
            Επιβεβαίωση
          </button>
          {error && <div className="auth-error">{error}</div>}
        </div>
      )}

      {step === 3 && (
        <div className="step">
          <h2>🔑 Νέος Κωδικός</h2>
          <p className="password-rules">
            Ο κωδικός πρέπει να περιέχει τουλάχιστον 6 χαρακτήρες και ένα αγγλικό γράμμα.
          </p>
          <input
            type="password"
            placeholder="Νέος κωδικός"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <input
            type="password"
            placeholder="Επιβεβαίωση κωδικού"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <button className="green-button" onClick={handleChangePassword}>
            Αλλαγή κωδικού
          </button>
          {error && <div className="auth-error">{error}</div>}
          {message && <div className="success-message">{message}</div>}
        </div>
      )}

    </div>
  );
}

export default PasswordResetModal;
